import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
/* src/index.css or src/index.scss */
import "bootstrap/dist/css/bootstrap.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
